{
  "version": 1,
  "asset_id": "8148c5d7-4945-43ce-a165-99f7a0cd1d65",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8148c5d7-4945-43ce-a165-99f7a0cd1d65/hiatal-type-3-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8148c5d7-4945-43ce-a165-99f7a0cd1d65/hiatal-type-3-v3-1200.webp",
  "original_filename": "hiatal-type-3-v3-1200.webp",
  "size": 182164,
  "content_type": "image/webp",
  "created_at": "2026-10-28T22:48:24Z"
}
